module.exports = {"singular":"Event location","plural":"Event locations","date_range":"Date","name":"City"};